import{a as o}from"./chunk-PF6J6SIL.js";export{o as useStyleInjection};